const SENTINELS = new Set(['system', 'none', 'unassigned']);

export function sanitizeAssigneeId(
  raw: unknown,
  opts?: { resolveCurrentUser?: () => string | null | undefined },
): string | null {
  if (raw == null) return null;
  const id = String(raw).trim();
  if (!id) return null;
  const lower = id.toLowerCase();
  if (SENTINELS.has(lower)) return null;
  if (lower === 'current-user') {
    const resolved = opts?.resolveCurrentUser?.();
    if (resolved == null) return null;
    const out = String(resolved).trim();
    return out || null;
  }
  return id;
}
